import { render } from "./ui-pdfbox.vue?vue&type=template&id=e0b8c3fe"
import script from "./ui-pdfbox.vue?vue&type=script&lang=js"
export * from "./ui-pdfbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__